import Helper from "@/services/Helper"

export default class Default {
    filterParams() {
        return {
            params: {
                search: "",
                search_full_match: true,
                date: null,
                users: [],
                statuses: {
                    published: true,
                    scheduled: false,
                    removed: false,
                    draft: false,
                },
                shops: [],
                categories: [],
                type_visibility: 2,
                type_ids: [],
                is_moderate: 0,
                type_id: [],
                promocode: "",
            },
            saveForm: true,
            enable: true,
        }
    }

    prepareQuery(q) {
        let query = Helper.clone(q)

        return query
    }
}
